import * as React from 'react';
import { Category, isBrowser } from '@packages/common';

import { RecommendationChannel } from './types';
import { DyRecommendations } from './DyRecommendations';

export interface RecommendationsContainerProps {
  fallbackTitle?: string;
  recommendationChannel: RecommendationChannel;
  isSorted?: boolean;
  service?: 'product' | 'content';
  slidesToShow?: number[];
  /*
   * @description: loads recommendations after page is scrolled
   * @default: true
   */
  lazy?: boolean;
  category?: Category;
}

export const RecommendationsContainer: React.FC<RecommendationsContainerProps> = ({
  recommendationChannel,
  fallbackTitle,
  isSorted,
  service,
  slidesToShow,
  category,
  lazy = true,
}) => {
  const [isReady, setIsReady] = React.useState(!lazy);

  React.useEffect(() => {
    const isScrolled = () => window.scrollY >= 400;

    if (isScrolled() && !isReady) {
      setIsReady(true);
    }

    const handler = () => {
      if (!isReady && isScrolled()) {
        setIsReady(true);
      }
    };
    window.addEventListener('scroll', handler);
    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [setIsReady, isReady]);

  if (!isBrowser() || !isReady) {
    return null;
  }

  return (
    <DyRecommendations
      recommendationChannel={recommendationChannel}
      fallbackTitle={fallbackTitle}
      isSorted={isSorted}
      service={service}
      slidesToShow={slidesToShow}
      category={category}
    />
  );
};
